export default __webpack_public_path__ + "static/media/discover.f73df556.png";